export const SITE = {
  name: "Mysore Yellow Pages",
  shortName: "MYP",
  tagline: "Your hyperlocal business directory for Mysore & beyond",
  url: "https://www.mysoreyellowpages.com",
  email: "mysoreyellowpages@gmail.com",
  phone: "+91 81235 84806",
  phoneHref: "+918123584806",
  gstin: "GST awaited",
  address: {
    line1: "6th Main, E&F Block, Ramakrishna Nagar",
    line2: "Chaduranga Road",
    city: "Mysore",
    region: "Karnataka",
    postalCode: "570023",
    country: "India",
  },
  addressOneLine:
    "6th Main, E&F Block, Ramakrishna Nagar, Chaduranga Road, Mysore, Karnataka 570023",
  regions: ["Mysore", "Mandya", "Chamarajanagar", "Kodagu (Coorg)"] as string[],
  social: [
    { name: "Facebook", icon: "ri-facebook-fill", href: "https://facebook.com" },
    { name: "Instagram", icon: "ri-instagram-line", href: "https://instagram.com" },
    { name: "X", icon: "ri-twitter-x-fill", href: "https://x.com" },
    { name: "LinkedIn", icon: "ri-linkedin-fill", href: "https://linkedin.com" },
    { name: "YouTube", icon: "ri-youtube-fill", href: "https://youtube.com" },
  ],
};

export const IMG = {
  hero: "https://storage.helloreaddy.io/project_files/1de7400a-5e8b-4745-9318-b93fcd41824e/19c1ab7c-771c-43d2-a7a3-91524d69a895_compressed_Mysore-Palace-Mysuru-Karnataka-India.webp",
  cta: "https://readdy.ai/api/search-image?query=Storefront%20of%20a%20small%20Indian%20local%20business%20at%20dusk%20with%20warm%20glowing%20signage%2C%20amber%20and%20teal%20moody%20tones%2C%20cinematic%20editorial%20photography%2C%20soft%20bokeh%2C%20empty%20space%20on%20the%20left%20for%20text&width=1400&height=700&seq=myyp-cta-01&orientation=landscape",
  tourist: "https://storage.helloreaddy.io/project_files/1de7400a-5e8b-4745-9318-b93fcd41824e/19c1ab7c-771c-43d2-a7a3-91524d69a895_compressed_Mysore-Palace-Mysuru-Karnataka-India.webp",
};